export async function selectThumbnail(files) {
  if (files.length !== 1) throw new Error('Drop one image for this video.');
  const file = files[0];
  if (
    !['image/jpeg', 'image/png'].includes(file.type) ||
    !file.size ||
    // The server compresses images over YouTube's 2 MB limit to fit.
    file.size > 100 * 1024 * 1024
  )
    throw new Error('Choose a JPG or PNG image up to 100 MB.');
  const bitmap = await createImageBitmap(file).catch(() => {
    throw new Error(
      'This image could not be opened. Choose another JPG or PNG.',
    );
  });
  bitmap.close();
  return file;
}

// undefined preserves the saved image; null removes it. Creation and editing
// send the chosen image with the form, avoiding a second, partially saved step.
export async function thumbnailPayload(file) {
  if (!file) return file;
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () =>
      reject(
        new Error('Could not read the thumbnail. Choose the image again.'),
      );
    reader.onload = () =>
      resolve({
        fileName: file.name,
        contentType: file.type,
        data: reader.result.split(',')[1],
      });
    reader.readAsDataURL(file);
  });
}
